/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RecorderType {
    Undefined = 0,
    ProRecorder = 2,
    OsceRecorder = 4,
    OsceDetailRecorder = 16,
}
